import { render, staticRenderFns } from "./AdminSecurity.vue?vue&type=template&id=2fab0dd6&scoped=true"
import script from "./AdminSecurity.vue?vue&type=script&lang=js"
export * from "./AdminSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab0dd6",
  null
  
)

export default component.exports